<template>
    <v-layout row wrap>
        <v-flex xs0 sm2 md3 lg4 />
        <v-flex xs12 sm8 md6 lg4>
            <slot />
        </v-flex>
        <v-flex xs0 sm2 md3 lg4 />
        <v-flex xs12 class="full_content">
            <v-layout row wrap>
                <v-flex xs12 sm6 md8 class="custom_flex_padding_right">
                    <h3 class="custom_text_add_field">
                        Saisie des contenus
                    </h3>
                    <v-file-input v-model="modelFiles" :rules="modelRules" :accept="modelTypes" filled
                                  class="ra3d_file_upload" label="Ajoutez un contenu 3D" @change="onChangeModel" />
                    <v-layout>
                        <v-flex xs4>
                            <v-text-field v-model="coordinateX" type="number" filled mask="###"
                                          label="Position X en %" />
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field v-model="coordinateY" type="number" filled mask="###"
                                          label="Position Y en %" />
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field v-model="coordinateZ" type="number" filled mask="###"
                                          label="Position Z en %" />
                        </v-flex>
                    </v-layout>
                    <v-text-field v-model="scale" type="number" filled mask="###" label="Scale en %" />
                    <v-text-field v-model="mode" type="number" filled mask="#" label="Mode (0, 1, 2)" />
                    <v-layout>
                        <v-flex xs4>
                            <v-text-field v-model="rotationX" type="number" filled mask="###"
                                          label="Rotation X en °" />
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field v-model="rotationY" type="number" filled mask="###"
                                          label="Rotation Y en °" />
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field v-model="rotationZ" type="number" filled mask="###" z
                                          label="Rotation Z en °" />
                        </v-flex>
                    </v-layout>
                    <v-layout class="publish_btn">
                        <v-flex xs6 />
                        <v-flex xs6>
                            <v-btn class="custom_btn_add_field custom_btn_color_blue"
                                   :loading="fileUploading" :disabled="!modelValid" @click="updateAction">
                                Publier les changements
                                <template v-slot:loader>
                                    <span class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                    </span>
                                </template>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex x0 sm6 md4 class="custom_flex_padding_left">
                    <h3 class="custom_text_add_field">
                        Image à scanner
                    </h3>
                    <p v-if="imageToScan" class="custom_text_add_field_p">
                        Testez votre story en scannant cette image depuis votre téléphone
                    </p>
                    <p v-else class="custom_text_add_field_p">
                        Pour tester votre augmentation, veuillez ajouter une image dans l'onglet Paramètres.
                    </p>
                    <v-img v-if="imageToScan" :src="imageToScan"
                           aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-layout fill-height align-center justify-center ma-0>
                                <v-progress-circular indeterminate color="grey lighten-5" />
                            </v-layout>
                        </template>
                    </v-img>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { fileMixinModel } from '../../global/FileMixinModel';

    export default {
        name: 'Ra3d',
        mixins: [fileMixinModel],
        computed: {
            ...mapGetters('actions', ['action']),
            file: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.file;
                },
                set (file) {
                    this.$store.commit('actions/ra3d/SET_DATA', { file });
                }
            },
            coordinateX: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.coordinate[0];
                },
                set (coordinateX) {
                    this.$store.commit('actions/ra3d/SET_DATA_COORDINATE', { index: 0, value: coordinateX });
                }
            },
            coordinateY: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.coordinate[1];
                },
                set (coordinateY) {
                    this.$store.commit('actions/ra3d/SET_DATA_COORDINATE', { index: 1, value: coordinateY });
                }
            },
            coordinateZ: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.coordinate[2];
                },
                set (coordinateZ) {
                    this.$store.commit('actions/ra3d/SET_DATA_COORDINATE', { index: 2, value: coordinateZ });
                }
            },
            scale: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.scale;
                },
                set (scale) {
                    this.$store.commit('actions/ra3d/SET_DATA', { scale });
                }
            },
            mode: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.mode;
                },
                set (mode) {
                    this.$store.commit('actions/ra3d/SET_DATA', { mode });
                }
            },
            rotationX: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.rotation[0];
                },
                set (rotationX) {
                    this.$store.commit('actions/ra3d/SET_DATA_ROTATION', { index: 0, value: rotationX });
                }
            },
            rotationY: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.rotation[1];
                },
                set (rotationY) {
                    this.$store.commit('actions/ra3d/SET_DATA_ROTATION', { index: 1, value: rotationY });
                }
            },
            rotationZ: {
                get () {
                    return this.$store.state.actions.ra3d.currentRa3d.rotation[2];
                },
                set (rotationZ) {
                    this.$store.commit('actions/ra3d/SET_DATA_ROTATION', { index: 2, value: rotationZ });
                }
            },
            imageToScan: function () {
                return this.$store.state.actions.augmentation.image_id
                    ? '/image/' + this.$store.state.actions.augmentation.image_id : null;
            }
        },
        watch: {
            modelData: function (newValue) {
                this.file = newValue;
            }
        },
        mounted () {
            this.emitVerification();
            this.initModelFiles(this.file, this.$cdnPath);
            this.dragAndDrop('.ra3d_file_upload', this.onChangeModel, '.glb');
        },
        methods: {
            ...mapActions('actions/ra3d', ['ra3dUpdate']),
            dragAndDrop: function (element, callback, typeAccept) {
                this.$el.querySelector(element).addEventListener('drop', (e) => {
                    e.preventDefault();
                    if (typeAccept.indexOf(e.dataTransfer.files[0].type) !== -1) {
                        callback(e.dataTransfer.files[0]);
                    } else {
                        this.$toasted.error('Type of file don\'t accepted');
                    }
                });
                this.$el.querySelector(element).addEventListener('dragleave', (e) => {
                    e.preventDefault();
                });
                this.$el.querySelector(element).addEventListener('dragover', (e) => {
                    e.preventDefault();
                });
            },
            emitVerification: function () {
                this.$emit('verificationValues', {
                    state: true,
                    data: {}
                });
            },
            updateAction: function () {
                this.ra3dUpdate().then(() => {
                    this.$toasted.success('Changement correctement pris en compte.');
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .layout {
        width: 100%;
        margin: 0;
    }

    #ra_3d_section .full_content {
        background-color: rgba(0, 0, 0, 0.05);
        padding: 10px 20px 20px 20px !important;
        min-height: calc(100vh - 215px);
    }

    .custom_text_add_field {
        margin-right: 10px;
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        margin-top: 10px;
    }

    .custom_flex_data {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    .publish_btn {
        position: relative;
    }

    .publish_btn button {
        width: 100%;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
    }

    .custom_flex_padding_right {
        padding-right: 20px !important;
    }

    .custom_flex_padding_left {
        padding-left: 20px !important;
    }
</style>
